/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VoucherCategory
 */
export interface VoucherCategory {
    /**
     * 
     * @type {number}
     * @memberof VoucherCategory
     */
    voucherId?: number;
    /**
     * 
     * @type {number}
     * @memberof VoucherCategory
     */
    categoryId?: number;
    /**
     * 
     * @type {Date}
     * @memberof VoucherCategory
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof VoucherCategory
     */
    updatedAt?: Date;
}

export function VoucherCategoryFromJSON(json: any): VoucherCategory {
    return VoucherCategoryFromJSONTyped(json, false);
}

export function VoucherCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): VoucherCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'voucherId': !exists(json, 'voucherId') ? undefined : json['voucherId'],
        'categoryId': !exists(json, 'categoryId') ? undefined : json['categoryId'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}

export function VoucherCategoryToJSON(value?: VoucherCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'voucherId': value.voucherId,
        'categoryId': value.categoryId,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}


